import _ from 'lodash';
import formatDate from 'date-fns/format';
import ago from 's-ago';

import { legacyParse } from '@date-fns/upgrade/v2';
import {
  formatMoney,
  CURRENCY_THAT_USES_DOT_IN_THOUSAND,
} from '@/utils/currency';
import { CurrencyCode } from '@clearbanc/data-common-types';

const $filters = {
  currency: formatMoney,

  noDecimal: (value: string, currencyCode?: string): string => {
    return value.split(
      // spliting according to the currency type (if is dot or comma in the decimal part)
      // if the currency uses a dot in thousand, then it uses a comma in the decimal part
      CURRENCY_THAT_USES_DOT_IN_THOUSAND.includes(currencyCode as CurrencyCode)
        ? ','
        : '.',
    )[0];
  },

  // return up to 2 decimals
  // the "+" will get rid of unnecessary trailing zeros
  percent: (value: number): string => `${+(value * 100).toFixed(2)}%`,

  'friendly-date': (value?: any) => {
    if (!value) return '---';
    return formatDate(legacyParse(value), 'MMMM do, yyyy');
  },

  friendlyDate: (value?: any): string => {
    if (!value) return '---';
    return formatDate(legacyParse(value), 'MMMM dd, yyyy');
  },

  date: (value?: any): string => {
    if (!value) return '---';
    return formatDate(legacyParse(value), 'yyyy-MM-dd');
  },
  datetime: (value?: any): string => {
    if (!value) return '---';
    return formatDate(legacyParse(value), 'yyyy-MM-dd @ h:mma');
  },
  timeago: (value?: any): string => {
    if (!value) return '---';
    if (_.isDate(value)) return ago(value);
    return ago(new Date(value));
  },

  capitalize: (value?: any): string => {
    if (!value) return '---';
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  month: (value: number): string => {
    const months: Record<number, string> = {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Aug',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Dec',
    };

    return months[value] || 'N/A';
  },
};

export { $filters };
